import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ResponsiveImage from '@artemis/components/ResponsiveImage';
import { FormattedMessage } from '@artemis/integrations/contentful/utils';
import { LIST_TYPE_VALUES } from '@artemis/utils/query/constants';

const EmptyContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.grey[300]};
  display: grid;
  grid-gap: 50px;
  justify-items: center;
  padding: 50px 30px;
`;

const Image = styled(ResponsiveImage)`
  width: 140px;
`;

const EmptyMessage = styled.p`
  text-align: center;
  white-space: pre-wrap;
  span {
    font-weight: ${props => props.theme.typography.fontWeightMedium};
  }
`;

const EmptyList = ({ noSearchQuery, searchQuery, listType }) => {
  const getImageId = () => {
    if (!noSearchQuery) return 'promo.emptySearchResults.img';
    return listType === LIST_TYPE_VALUES.NEARBY
      ? 'promo.emptySearchResults.img'
      : 'promo.emptySearchResultsAlt.img';
  };

  return (
    <EmptyContainer>
      <Image id={getImageId()} />
      <EmptyMessage>
        {noSearchQuery ? (
          <FormattedMessage
            entry={
              listType === LIST_TYPE_VALUES.NEARBY
                ? 'promo.tooFarSearchResult'
                : 'promo.allClosedSearchResult'
            }
          />
        ) : (
          <FormattedMessage
            entry="promo.noSearchResults"
            values={{
              query: searchQuery,
              bold: text => <span>{text}</span>,
            }}
          />
        )}
      </EmptyMessage>
    </EmptyContainer>
  );
};

EmptyList.propTypes = {
  noSearchQuery: PropTypes.bool,
  searchQuery: PropTypes.string,
  listType: PropTypes.string,
};

export default EmptyList;
